import React from 'react'
import AdminNavbar from '../Navbar/AdminNavbar'
import UserNavbar from '../Navbar/UserNavbar'
import { Button, Input, Select, Spin, Table } from "antd";
import { AiFillAccountBook } from "react-icons/ai";
import { ProductMasterAdd, ProductMasterBlock, ProductMasterDelete, ProductMasterFindAll, ProductMasterUpdate } from '../Api/All_Api';
import { toast } from "react-toastify";
import { Option } from 'antd/es/mentions';
import { useState,useEffect } from 'react'; 
import axios from 'axios';
import { Tooltip } from 'antd';
import { useNavigate } from 'react-router-dom';
import TitleNavbar from '../Navbar/TitleNavbar';

const ProductMaster = () => {
  const role = sessionStorage.getItem('role');
 const branchId = sessionStorage.getItem('branchId');

   const sessionYear = sessionStorage.getItem('sessionYear');
 const navigate = useNavigate();
     useEffect(() => {
       if (!sessionYear) {
         sessionStorage.clear();
         navigate('/')
       }
     },[])
  
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productName, setProductName] = useState('');
  const [productId, setProductId] = useState('');
  const [updateButton, setUpdateButton] = useState(false);
  const [saveButton, setSaveButton] = useState(true);

  const [errors, setErrors] = useState({
    productName: '',
  });

  const handleSearch = (value) => {
    const filtered = allProducts.filter((item) =>
      Object.values(item).some((val) =>
        val?.toString().toLowerCase().includes(value.toLowerCase()))
    );
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };

  const handleCancel = () => {
    setUpdateButton(false);
    setSaveButton(true);
    setProductName('');
    setErrors({});
    fetchProducts();
  };

  useEffect(() => {
    fetchProducts();
  }, []);


  const handleSubmit = async () => {
    let isValid = true;
    const errorObj = {};
    if (!productName) {
      isValid = false;
      errorObj.productName = "Product name is required *";
    }

    setErrors(errorObj);

    if (!isValid) return;
    setLoading(true);
    const bodyData = {
      status:1,
      productName:productName,
      branchId:parseInt(branchId),
    };

    try {
      const response = await axios.post(ProductMasterAdd, bodyData);
      if (response.data === "CREATED") {
        toast.success('Product added successfully!');
        fetchProducts();
        handleCancel();
      } else if (response.data === "ALREADYEXISTS") {
        toast.warn('Product already exists!');
        handleCancel();
      }
    } catch (error) {
      console.error('Error during API call:', error);
      toast.error('Error occurred while submitting data');
    }
    finally{
      setLoading(false);
    }
  };

  const handleEditDataButton = (item) => {
    setUpdateButton(true);
    setSaveButton(false);
    setProductName(item.productName);
    setProductId(item.id);
  };

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${ProductMasterFindAll}?branchId=${branchId}`);
      if (response.data) {
        setAllProducts(response.data);
        setFilteredData(response.data);
        setTotalEntries(response.data.length);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      toast.error('Failed to fetch product data');
    }
  };

  const handleUpdate = async () => {
    let isValid = true;
    const errorObj = {};
    if (!productName) {
      isValid = false;
      errorObj.productName = "Product name is required *";
    }

    setErrors(errorObj);

    if (!isValid) return;
setLoading(true);
    const bodyData = {
      id: productId,
      productName:productName,
      branchId:branchId,
      status:1,
    };

    try {
      const response = await axios.put(ProductMasterUpdate, bodyData);
      if (response.data === "UPDATED") {
        toast.success('Product updated successfully!');
        fetchProducts();
        handleCancel();
      } else if (response.data === "ALREADYEXISTS") {
        toast.warn('Product already exists!');
        handleCancel();
      }
    } catch (error) {
      console.error('Error during API call:', error);
      toast.error('Error occurred while updating data');
    }
    finally{
      setLoading(false);
    }
  };

  // const handleDeleteData = async (item) => {
  //   const confirmDelete = window.confirm(`Are you sure you want to delete ${item.productName}?`);
  //   if (!confirmDelete) return;

  //   try {
  //     const response = await axios.delete(`${ProductMasterDelete}?id=${item.id}`);
  //     if (response.data === "DELETED") {
  //       toast.success('Product deleted successfully!');
  //       fetchProducts();
  //       handleCancel();
  //     }
  //   } catch (error) {
  //     console.error('Error during delete operation:', error);
  //     toast.error('Error occurred while deleting product');
  //   }
  // };
  const toggleBlockStatus = async (item) => {
    const confirmDelete = window.confirm(`Are you sure you want to  ${item.status == 0 ? 'activate' : 'block'} ${item.productName}?`);
    if (!confirmDelete) return;
    try {
     
      const updatedActiveStatus = item.status == 0 ? 1 : 0;
      
   
      const response = await axios.put(`${ProductMasterBlock}?id=${item.id}&block=${updatedActiveStatus}` );
  
      if (response.data === "BLOCKED" || response.data === "UNBLOCKED") {
      
        setAllProducts(
          allProducts.map((c) =>
            c.id === item.id ? { ...c, status: updatedActiveStatus } : c
          )
        );
  
        fetchProducts();
        toast.success(`Product ${updatedActiveStatus === 0 ? 'blocked' : 'unblocked'} successfully!`);
      } else {
        
        toast.error('Failed to update block status.');
      }
    } catch (error) {
      // Catch errors and display a toast message
      toast.error('Error updating block status!');
      console.error('Axios error:', error);
    }
  };
  const columns = [
    {
      title: "Sr.No.",
      dataIndex: "",
      key: "index",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Product Name",
      dataIndex: "productName",
      key: "productName",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      key: "status",
      render: (text) => (
       <span
       style={{
         display: "inline-block",
         padding: "2px 10px",
         color: "white",
         borderRadius: "4px",
         backgroundColor: text == "0" ? "red" : "green",
       }}
     >
       {text == "0" ? "Blocked" : "Active"}
     </span>
      ),
    },
    {
      title: " Edit",
      key: "edit",
      width:"60px",
      render: (text, record) => (
        <div className='text-center'>
          <span 
          className='me-1 me-lg-2'
            type="submit"
            style={{ fontSize: "12px", color: "orange" }}
            onClick={() => handleEditDataButton(record)}
          >
           <Tooltip title="Edit"> <i className="fa-solid fa-pen-to-square"></i></Tooltip>
          </span>
          {/* <span
            type="submit"
            style={{ fontSize: "12px", color: "blue", marginLeft: "10px" }}
            onClick={() => handleDeleteData(record)}
          >
            <i className="fa-solid fa-trash"></i>
          </span> */}
        
        </div>
      ),
    },
    {
      title: "Block",
      key: "block",
      width:"60px",
      render: (text, record) => (
        <div className='text-center'>
         
          <span
           className='me-1 me-lg-2'
          type="button"
          style={{
            fontSize: "12px", 
            color: record.status === 0 ? "red" : "green", 
            
            cursor: "pointer"
          }}
          onClick={() => toggleBlockStatus(record)} 
        >
        <Tooltip title={record.status === 0 ? "Blocked":"Active"}>
          <i className={`fa-solid ${record.status == 0 ? 'fa-lock' : 'fa-unlock'}`}></i> </Tooltip>
        </span>
        </div>
      ),
    },
  ];

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th {...restProps} style={{ backgroundColor: "#000", color: "#fff", padding: "10px", fontSize: "13px", borderRadius: "0px" }}>
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr {...restProps} style={{ backgroundColor: "#f0f7fd" }}>
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td {...restProps} style={{ padding: "8px" }}>
          {children}
        </td>
      ),
    },
  };

      //===================================
const navbg = {
  backgroundColor:"#f79400",
  boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  fontSize: "19px",
  color:"#fff"
}
//=====================================================


  return (
    <>
      <AdminNavbar />
      <div className="p-0 m-0">
        {/* Header Section */}
        <div className="row m-0" style={navbg}>
          <div className="col-12" style={{ display: "flex", alignItems: "center", justifyContent: "start",  }}>
          <span className="px-md-5" style={{ flexGrow: 1 }}>
      <AiFillAccountBook /> &nbsp;
      Product Master
    </span>

    {/* TitleNavbar (Right-aligned) */}
    <span>
      <TitleNavbar />
    </span>
                      
          </div>
        </div>

        {/* Form Section */}
        <div className='row m-0 p-0 pt-5'>
          <div className='col-12 col-lg-3'></div>
          <div className='col-12 col-lg-6'>
              <div className="row px-md-5 mt-3  m-0">

          <div className="col-12 pt-1">
        <div className="row m-0">
          <div className="col-3 p-0 lableStyle">
                <label className="labels"  style={{fontSize:16}}>Product Name:</label>
              </div>
              <div className="col-9 col-lg-6">
                <Input
                  placeholder="Enter Product Name"
                  value={productName}
                  onChange={(e) => setProductName(e.target.value)}
                />
                {errors.productName && <div className="errorField">{errors.productName}</div>}
              </div>
            </div>
          </div>
       

          <div className="col-12 text-center pt-3">
            <Button
              type="button"
              onClick={handleCancel}
              className="CancelBtn mx-1"
              
            >
              Cancel
            </Button>
            {saveButton && (
              <Button
                type="button"
                className="SubmitBtn mx-1"
              
                onClick={handleSubmit}
                disabled={loading} // Disable button while loading
      >
        {loading ? <Spin size="small" /> : 'Save'}
              </Button>
            )}
            {updateButton && (
              <Button
                type="button"
                className="UpdateBtn mx-1"
              
                onClick={handleUpdate}
                disabled={loading} // Disable button while loading
      >
        {loading ? <Spin size="small" /> : 'Update'}
              </Button>
            )}
          </div>

          <div className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid #bfb597" }}></div>
        </div>
        </div>

          <div className='col-12 col-md-2 col-lg-4'></div>

        {/* Table Section */}
        <div className="row m-0 p-2 mb-5 pt-md-0 mt-3">
          <div className="col-12 col-md-2"></div>
          <div className="col-12 col-md-8 py-3 shadow border" style={{ marginBottom: "50px", backgroundColor: "white" }}>
            <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                <Select
                  defaultValue={pageSize}
                  onChange={handlePageSizeChange}
                  style={{ width: 120, textAlign: "center" }}
                >
                  <Option value={10}>10</Option>
                  <Option value={20}>20</Option>
                  <Option value={30}>30</Option>
                </Select>
              </div>

              <div className="pt-4 pt-md-0">
                <Input.Search placeholder="Search" onSearch={handleSearch} style={{ width: 200, marginBottom: 16 }} />
              </div>
            </div>

            <div style={{ backgroundColor: "white" }}>
              <Table
                bordered
                style={{ padding: "0px 20px", overflowX: "auto"  }}
                columns={columns}
                dataSource={filteredData}
                pagination={{
                  pageSize: pageSize,
                  total: totalEntries,
                  showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                  current: currentPage,
                  onChange: (page) => setCurrentPage(page),
                }}
                showSorterTooltip={false}
                rowKey={(record) => record.id}
                components={components}
              />
            </div>
          </div>
          <div className="col-12 col-md-2"></div>
        </div>
      </div>
   </div>
    </>
  );
};


export default ProductMaster